export default __webpack_public_path__ + "static/media/AB_Main.cfde5bb7.png";